/**
 * Asynchronously loads the component for AdminCourseDetails
 */

import { lazyLoad } from "utils/loadable";

export const AdminCourseDetails = lazyLoad(
  () => import("./index"),
  (module) => module.AdminCourseDetails
);